import React, { useCallback, useEffect, useState } from 'react';
import ProductGroup from '../components/ProductGroup/ProductGroup';
import { useGetCategories } from '../../../../hooks/use-get-categories';
import { Category } from '../../../../interfaces/category.interface';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslate } from '@tolgee/react';
import { CompanyService } from '../../../../services/company.services';
import { toastVariant } from '../../../../components/ToastVariant/toastVariant';

const SelectProductGroup: React.FC = () => {
	const { t } = useTranslate();
	const { storeId } = useParams();
	const [userCountry, setUserCountry] = useState<string>();
	const [groups] = useGetCategories(
		{
			countryCode: userCountry,
		},
		'producer',
	);
	const navigate = useNavigate();

	const onSelect = (category: Category): void => {
		navigate(`${category.id}/categories`);
	};

	const getMyCompanyCallback = useCallback(async () => {
		try {
			const { data } = await CompanyService.getMeCompany();
			setUserCountry(
				data.countryCode === 'MD'
					? 'MDA'
					: data.countryCode === 'PL'
					? 'POL'
					: '',
			);
		} catch (error) {
			toastVariant(`Something went wrong. ${error?.toString()}`, true);
		}
	}, []);

	useEffect(() => {
		getMyCompanyCallback().then(() => {});
	}, [getMyCompanyCallback]);

	const breadcrumbs = [
		{
			name: t('selectProductGroup.countryStore', 'Country store'),
			onClick: () => navigate(`/products/${storeId}`),
		},
		{
			name: t('selectProductGroup.group', 'Group'),
			onClick: () => {},
		},
	];

	return (
		<div className="w-full h-full flex flex-col">
			<div className="h-full w-full my-[60px] lg:my-0 px-[30px] lg:px-0">
				<ProductGroup
					groups={groups?.items}
					onSelect={onSelect}
					title={t(
						'selectProductGroup.selectProductGroup',
						'Select product group',
					)}
					breadcrumbs={breadcrumbs}
					countryCode={userCountry}
					showClose={true}
				/>
			</div>
		</div>
	);
};
export default SelectProductGroup;
